<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
        scrollable
        zIndex="210"
    >
        <v-card v-if="dialog">
            <v-toolbar flat dense>
                <h2 class="text-h6 text-primary-700 text-ellipsis-overflow">
                    Edit Pipeline
                </h2>
                <v-spacer></v-spacer>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="px-4 py-6">
                <!-- name, client, contact, and notes -->
                 <v-row>
                    <v-col cols="12">
                        <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.name"
                            label="Pipeline Name"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-combobox
                            outlined
                            dense
                            hide-details
                            v-model="form.client"
                            :search-input.sync="client.search"
                            :items="client.items"
                            :loading="client.loading"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Client"
                            clearable
                            return-object
                            hide-no-data
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                        <v-combobox
                            outlined
                            dense
                            hide-details
                            v-model="form.contact"
                            :search-input.sync="contact.search"
                            :items="contact.items" 
                            :loading="contact.loading"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Contact"
                            clearable
                            return-object
                            hide-no-data
                        ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            v-model="form.notes"
                            label="Notes (Optional)"
                            outlined
                            dense
                            hide-details
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    @click="closeDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    depressed
                    @click="editPipeline"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

    export default {
        data() {
            return {
                dialog: false,
                id: null,
                form:{
                    name: '',
                    client: null,
                    contact: null,
                    notes: '',
                },
               
                client: {
                    items: [],
                    loading: false,
                    search: null,
                },
                contact: {
                    items: [],
                    loading: false,
                    search: null,
                }

            }
        },
        methods: {
            closeDialog() {
                this.dialog = false;
            },
            openDialog(entity) {
                this.dialog = true;
                this.fillForm(entity)
                this.id = entity.id
            },

            fillForm(entity){
                this.form.name = entity.name
                this.form.notes = entity.notes
                if(entity.client_id){
                    this.form.client = {
                        value: entity.client_id,
                        label: entity.client.data.name,
                    }
                    this.client.items.push(this.form.client)
                }
                
                if(entity.contact_id){
                    this.form.contact = {
                        value: entity.contact_id,
                        label: entity.contact.data.name,
                    }
                    this.contact.items.push(this.form.contact)
                }
            },

            editPipeline() {
                this.$http.put(`/pipelines/${this.id}`, {
                    name: this.form.name,
                    client_id: this.form.client ? this.form.client.value : null,
                    contact_id: this.form.contact ? this.form.contact.value : null,
                    notes: this.form.notes,
                })
                .then(response => {
                    this.$emit("edited")
                    this.dialog = false
                })
                .catch(error => {
                    console.log(error)
                })
            },

            searchCompanies(prop){
                this.clientsLoading = true
                this.Clients = []
                this.getCompanies(prop)
            },

            searchContacts(prop){
                this.contactsLoading = true
                this.Contacts = []
                this.getContacts(prop)
            },

            async getCompanies(prop){
                this.$http.get("/companies",{
                    params: {
                        q: prop,
                        per_page: 50,
                    }
                }).then(response => {
                    this.client.items = response.data.data.map(company => {
                        return {
                            value: company.id,
                            label: company.name,
                        }
                    })
                    this.client.loading = false
                }).catch(error => {
                    this.client.loading = false
                })
            },

            async getContacts(prop){
                this.$http.get("/users",{
                    params: {
                        q: prop,
                        per_page: 50,
                    }
                }).then(response => {
                    this.contact.items = response.data.data.map(contact => {
                        return {
                        value: contact.id,
                        label: contact.name,
                        }
                    })
                    this.contact.loading = false
                }).catch(error => {
                    this.contact.loading = false           
                })
            },

            debounce(fn, delay) {
                clearTimeout(this._timerId)
                this._timerId = setTimeout(() => {
                    fn();
                }, delay);
            }
        },

        watch:{
            'client.search': function(val){
                if(!val) return
                this.debounce(() => {
                    this.client.loading = true
                    this.getCompanies(val)
                }, 500)
            },
            'contact.search': function(val){
                if(!val) return
                this.debounce(() => {
                    this.contact.loading = true
                    this.getContacts(val)
                }, 500)
            },
        }
    }
</script>